import ApiService from "../../../Api/ApiService";
import { IProfileLeaveAttendancePopup } from "../../../Types/UserProfileDetails";
import { rootApi } from "..";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

interface SummaryResponse {
  status?: boolean;
  success?: boolean;
  message?: string;
  data: IProfileLeaveAttendancePopup | { leave_attendance_popup: IProfileLeaveAttendancePopup };
}
class AttendanceSummaryService extends ApiService {
  getSummary(params: { userId: string; startDate: string; endDate: string }): Promise<SummaryResponse> {
    const query = new URLSearchParams({ start_date: params.startDate, end_date: params.endDate });
    return this.get<SummaryResponse>(`/employee/attendance-leave-summary/${encodeURIComponent(params.userId)}?${query}`);
  }
}
const service = new AttendanceSummaryService();
const endpoints = [{ name: "getAttendanceLeaveSummary", type: "query", tagType: "EmployeeAttendanceInfo", serviceFn: (params: { userId: string; startDate: string; endDate: string }) => service.getSummary(params) }] as const;
const api = rootApi.injectEndpoints({ endpoints: (builder) => makeEndpoints(builder, endpoints) });
export const { useGetAttendanceLeaveSummaryQuery } = api;
